import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { useLocation } from "@reach/router";
import { parse } from "query-string";
import { useUrlFilter } from "Hooks/utils";

export default function Paginator(props) {
  const location = useLocation();
  const [filters, setFilters] = useUrlFilter(); // eslint-disable-line no-unused-vars
  const [activePage, setActivePage] = useState(1);
  const { totalItemsCount, pageRangeDisplayed } = props;

  useEffect(() => {
    let pageNumber = parse(location.search).page;
    if (+pageNumber) {
      setActivePage(+pageNumber);
    } else {
      pageNumber = 1;
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const onPageChange = (page) => {
    setActivePage(page);
    setFilters({ page });
  };

  return (
    <div className="flex align-items-baseline">
      <Pagination
        activePage={activePage}
        itemsCountPerPage={process.env.REACT_APP_ITEM_PER_PAGE}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pageRangeDisplayed}
        itemClass={"page-item"}
        linkClass={"page-link"}
        hideNavigation={true}
        onChange={onPageChange}
      />
      {process.env.REACT_APP_ITEM_PER_PAGE <= totalItemsCount && (
        <span>
          Showing {process.env.REACT_APP_ITEM_PER_PAGE} of {totalItemsCount}
        </span>
      )}
    </div>
  );
}
